export default '/static/frontend/ReachDigital/12gobiking/dist/assets/vorkasse-aa88c5d1.png'